import dayjs from 'dayjs';
var date = {};

date.format = function (time, formatter) {
  formatter = formatter || 'YYYY-MM-DD HH:mm:ss';
  return dayjs(time).format(formatter);
};

date.dayBefore = function (dayBefore, formatter) {
  formatter = formatter || 'YYYY-MM-DD HH:mm:ss';
  return dayjs().subtract(dayBefore, 'day').format(formatter);
};

export default date;